module.exports = __webpack_public_path__ + "assets/img/btn-bj.115f8ad0.png";